import { Textarea } from '@heroui/react';
import { getIsTouchDevice } from '@/utils';
import { useMediaQuery } from '@/hooks';

interface TextFieldProps {
    label?: React.ReactNode;
    error?: boolean;
    helperText?: React.ReactNode;
    disabled?: boolean;
    value: string;
    handleValue: (value: string) => void;
    paddingBottom?: string;
}

const TextFieldComponent = ({ value, handleValue, disabled, helperText, paddingBottom, error, label }: TextFieldProps) => {
    const xs = useMediaQuery('(min-width: 500px)');
    const isTouchDevice = xs && getIsTouchDevice();

    return (
        <div style={{ paddingBottom: paddingBottom ?? '15px' }}>
            <Textarea
                label={label}
                isInvalid={error}
                errorMessage={helperText}
                isDisabled={disabled}
                value={value}
                onValueChange={handleValue}
                maxRows={6}
                minRows={4}
                classNames={{
                    input: `bg-default-200 rounded min-h-[150px] ${isTouchDevice ? 'text-2xl' : ''}`,
                    inputWrapper: 'bg-default-200',
                }}
            />
        </div>
    );
};

export default TextFieldComponent;
